import React from 'react';
import PromotionalHome from '../components/displays/PromotionalHome';

const Home = () => <PromotionalHome />;

export default Home;
